// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ZsczS","title":"styles_title__jERBD","description":"styles_description__6pEix","image":"styles_image__aM57l","content":"styles_content__bXP2H"};